import LoadingIcon from "Components/LoadingIcon";
import React, { Component } from "react";
import { IoIosCloseCircle } from "react-icons/io";
import styled from "styled-components";
import {
  AddIcon,
  AddIconContainer,
  ProjectImage,
  ProjectImageContainer
} from "Themes/StyledComponents";
import { Fonts } from "Themes";

const CloseIcon = styled(IoIosCloseCircle)`
  position: absolute;
  right: 0px;
  top: 0px;
  opacity: 1;
`;

const TextContainer = styled.div`
  width: 20%;
  font-family: ${Fonts.primaryFontFamily}
`;

class ProjectImages extends Component {
  state = {};
  render() {
    const { onImageClick, projectImages, onRemoveClick, onAddClick, editable } = this.props;

    if (!projectImages) return <LoadingIcon />;

    return (
      <div style={{ display: "flex", alignItems: "center" }}>
        {projectImages.map(({ image, id }, key) => {
          return (
            <ProjectImageContainer key={key} onClick={() => onImageClick(image)}>
              {editable && (
                <div style={{ position: "relative" }}>
                  <CloseIcon size={30} onClick={() => onRemoveClick(id)} />
                </div>
              )}
              <ProjectImage src={image} alt="Not found" />
            </ProjectImageContainer>
          );
        })}
          {editable && (
          <>
          {projectImages.length === 0 && <TextContainer>Click to add some images</TextContainer>}
          <AddIconContainer onClick={onAddClick}>
            <AddIcon fontSize={20} />
          </AddIconContainer>
          </>
        )}
      </div>
    );
  }
}

export default ProjectImages;
